import {
  Show,
  SimpleShowLayout,
  TextField,
  usePermissions,
} from "react-admin";

import { Typography, Divider } from "@mui/material";

const CategoryShow = () => {
  const { permissions = [] } = usePermissions();

  if (
    !(
      permissions.includes("assessments.read") ||
      permissions.includes("assessments.*") ||
      permissions.includes("*")
    )
  ) {
    return null;
  }

  return (
    <Show>
      <SimpleShowLayout
        sx={{
          maxWidth: 600,
          mt: 2,
          p: 2,
        }}
      >
        {/* Header */}
        <Typography variant="h6" gutterBottom>
          Category Details
        </Typography>
        <Divider sx={{ mb: 2 }} />

        {/* ID */}
        <TextField source="id" label="ID" />

        {/* Category Name */}
        <TextField
          source="category_name"
          label="Category Name"
        />

        {/* Subcategory Name */}
        <TextField
          source="subcategory_name"
          label="Subcategory Name"
        />

        {/* Description */}
        <TextField
          source="description"
          label="Description"
        />
      </SimpleShowLayout>
    </Show>
  );
};

export default CategoryShow;